import { FeatureFlag, useFeatureFlag } from '@/hooks/useFeatureFlags'
import { HiOutlineInformationCircle } from 'react-icons/hi'

import { Alert, Icon, Text } from '@chakra-ui/react'

import { IncidentQueryResult } from '@/graphql/generated/hooks'
import { IncidentSource } from '@/graphql/generated/schemas'

interface DispatchWhiteListAlertIProps {
  incident: IncidentQueryResult['data']['incident']
}

export const DispatchWhiteListAlert = ({
  incident,
}: DispatchWhiteListAlertIProps) => {
  const isQuickReportWhitelistEnabled = useFeatureFlag(
    FeatureFlag.quickReportWhitelist
  )
  const isQuickReportIncident = incident?.source === IncidentSource.QuickReport
  const shouldShowAlert = isQuickReportWhitelistEnabled && isQuickReportIncident

  if (!shouldShowAlert) {
    return null
  }

  return (
    <Alert
      bg='#DBE9FE'
      borderRadius='10px'
      color='#1D40B0'
      mb='24px'
      mt='16px'
      status='info'
    >
      <Icon
        as={HiOutlineInformationCircle}
        boxSize='20px'
        color='#1D40B0'
        mr='10px'
      />

      <Text fontSize='14px' fontWeight={400}>
        This QuickReport incident may not be visible to all guards.
      </Text>
    </Alert>
  )
}
